function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import isDeepEqual from "./is-deep-equal.js";
export var saveAll = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (state, oldState, _ref) {
    var prefix = _ref.prefix,
      driver = _ref.driver,
      serialize = _ref.serialize;
    if (!isDeepEqual(state, oldState)) {
      return driver.setItem("".concat(prefix, "rootState"), serialize(state, 'rootState'));
    }
  });
  return function saveAll(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();
export var saveAllKeyed = function saveAllKeyed(state, oldState, _ref3) {
  var prefix = _ref3.prefix,
    driver = _ref3.driver,
    serialize = _ref3.serialize;
  return Promise.all(Object.keys(state).map(function (key) {
    if (isDeepEqual(state[key], oldState[key])) {
      return Promise.resolve();
    }
    return driver.setItem("".concat(prefix).concat(key), serialize(state[key], key));
  }));
};
export var persist = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var oldState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _ref5 = arguments.length > 2 ? arguments[2] : undefined,
      prefix = _ref5.prefix,
      driver = _ref5.driver,
      persistWholeStore = _ref5.persistWholeStore,
      serialize = _ref5.serialize;
    try {
      var save = persistWholeStore ? saveAll : saveAllKeyed;
      yield save(state, oldState, {
        prefix: prefix,
        driver: driver,
        serialize: serialize
      });
    } catch (err) {
      console.warn('redux-remember: persist error', err);
    }
  });
  return function persist() {
    return _ref4.apply(this, arguments);
  };
}();
//# sourceMappingURL=persist.js.map